import getQuantityDisplayString from 'samples/getQuantityDisplayString';
import {Filter, FilterErrors, isContainerQuantityFilter} from 'search/SearchConstants';

export default function validateContainerQuantityFilters(filters: Array<Filter>): FilterErrors {
  return filters.map((filter) => {
    if (isContainerQuantityFilter(filter)) {
      const {value, units} = filter.value;
      if (value == null && units == null) {
        // Don't error if it's just a blank filter, since we ignore those.
        return null;
      }
      if (value == null) {
        return `${getQuantityDisplayString()} value must be specified.`;
      } else if (units == null) {
        return `${getQuantityDisplayString()} units must be specified.`;
      }
    }
    return null;
  });
}
